var baArticleList = {
	int:function(){
		console.log("Article Listing Services Ready.");
	},
	posts:{
		total:[],
		loaded:[],
		hidden:[],
		per:6,
		search:'',
		stash:'',
		searchTime:0,
		postData:[],
		popularData:[],
		sortingTimeout:null,
		init:function(){
			$(".ba-articles--loadmore").each(function(){
				if($(this).find(".ba-post-stage .ba--pgitem").length > 0){
					$(this).data('postData', $.trim($(this).find(".ba-post-stage").html().replace("\n", '').replace("\t", '')));
					$(this).data('popularData', $.trim($(this).find(".ba-post-stash").html().replace("\n", '').replace("\t", '')));
					$(this).find(".ba-post--loadmore").show();
					if($(this).find(".ba-post-stage .ba--pgitem[aria-hidden=true]").length === 0){
						$(this).find(".ba-post--loadmore").hide();
					}
					if($(this).find(".ba-post-stage").length > 0){
						$(this).data('stash', $(this).find(".ba-post-stage").html());
					}
					$(this).data('total', $(this).find(".ba-post-stage .ba--pgitem").length);
					$(this).data('loaded', $(this).data('total') - $(this).find(".ba-post-stage .ba--pgitem[aria-hidden=true]").length);
					$(this).data('hidden', $(this).data('total') - $(this).data('loaded'));
					if($(this).data('hidden') <= 0){
						$(this).find(".ba-post--loadmore").hide(); 
					}
				}
			});
		},
		calcPer:function(theparent){
			if(responder.curZindex === 10){ 
				theparent.data('per', 3);
			} else if(responder.curZindex === 8){
				theparent.data('per', 4);			
			} else {
				theparent.data('per', 6);
			}
		},
		loadMore:function(theparent){
			console.log("Loading more...");
			theparent.find(".ba-post-stage").find(".ba--pgitem").removeClass("first-focus");
			this.calcPer(theparent);
			if(theparent.data('hidden') > 0){
				var hiddenPosts = theparent.find(".ba-post-stage").find(".ba--pgitem[aria-hidden=true]").slice(0, theparent.data('per'));
				var scrollTarget = theparent.find(".ba-post-stage").find(".ba--pgitem[aria-hidden=false]").last();
				var scrollOffset = scrollTarget.height();
				var totalToShow = hiddenPosts.length;
				if(totalToShow > 0){
					var delay = 0;
					var fadeDelay = 150;
					hiddenPosts.each(function(){
						var item = $(this);
						//item.css("display", "block");
						item.attr("aria-hidden", "false");
						setTimeout(function(){ item.removeClass("hidden") }, delay);
						//if(delay == 0){ 
							//item.addClass("first-focus");
						//}
						delay += fadeDelay;
					});
					setTimeout(function(){ 
						if(theparent.find(".ba-post-stage").find(".ba--pgitem[aria-hidden=true]").length <= 0){
							theparent.find(".ba-post--loadmore").fadeOut(600);
						}
					}, delay + 100);
					$('html, body').animate({scrollTop: scrollTarget.offset().top + (scrollOffset-$("header").height()) }, 400);
					//$("#ba-post-stage").find(".ba--pgitem.first-focus").focus();
				} else {
					theparent.find(".ba-post--loadmore").fadeOut(600);
				}
			}
		},
		changeSort:function(type){
			var newsorteddata;
			switch(type){
				case "t":
					newsorteddata = this.postData
					break;
				case "p":
					newsorteddata = this.popularData;
					break;
			}
			$("#ba-post-stage").html('<div class="search-context" tabindex="0"><p class="bds--small">Sorting<span>.</span><span>.</span><span>.</span></p></div>');
			clearTimeout(this.sortingTimeout);
			this.sortingTimeout = setTimeout(function(){
				$("#ba-post-stage").html(newsorteddata);
				$(".ba-post--loadmore").show();
				if($("#ba-post-stage .ba--pgitem[aria-hidden=true]").length === 0){
					$(".ba-post--loadmore").hide();
				}
			}, 400);
			
		}
	}
};

$(document)
.ready(function(){
	baArticleList.int();
	baArticleList.posts.init();
})
.on("click", ".action--load-article-posts", function(e){
	e.preventDefault();
	var thisparent = $(this).parents(".ba-articles--loadmore");
	baArticleList.posts.loadMore(thisparent);
})
.on("change", "#ba-post--sort-article-filters input", function(){
	var sortType = $("input[name=post-sorting]:checked").val();
	baArticleList.posts.changeSort(sortType);
})
;

